import { api } from '@wellesley/openapi'
import { handleBasicResponse } from '@wellesley/openapi/helpers'

const uploadsApi = api.enhanceEndpoints({
  endpoints: {
    postApiV1UploadsByIdMeta: {
      async onQueryStarted(_, { queryFulfilled }) {
        await handleBasicResponse(queryFulfilled, 'Updated')
      },
    },
    postApiV1UploadsList: {
      async onQueryStarted(_, { queryFulfilled }) {
        await handleBasicResponse(queryFulfilled)
      },
    },
    postApiV1UploadsBatch: {
      async onQueryStarted(_, { queryFulfilled }) {
        await handleBasicResponse(queryFulfilled, 'Deleted')
      },
    },
    putApiV1UploadsByIdTags: {
      async onQueryStarted(_, { queryFulfilled }) {
        await handleBasicResponse(queryFulfilled)
      },
    },
  },
})

export const {
  usePostApiV1UploadsByIdMetaMutation,
  usePostApiV1UploadsListMutation,
  usePutApiV1UploadsByIdTagsMutation,
  usePostApiV1UploadsBatchMutation,
} = uploadsApi
